<template>
    <v-dialog v-model="$store.state.CircleK.Stmt" fullscreen>
        <v-card>
            <v-toolbar color="primary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text">
                    {{ title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$store.state.CircleK.Stmt = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container fluid>
                <v-row>
                    <v-col cols="4">
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    label="Search"
                                    v-model="searchNon"
                                    class="mb-5"
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-data-table
                            :headers="headersNon"
                            :items="Non"
                            :search="searchNon"
                            dense
                        >
                            <template v-slot:top>
                                <v-toolbar color="primary" dense>
                                    <v-spacer />
                                    <v-toolbar-title class="white--text">
                                        Non-Reconciled
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                            <!-- ... tus columnas ... -->
                            <template v-slot:footer>
                                <v-simple-table dense>
                                    <tr>
                                        <td
                                            colspan="2"
                                            width="40%"
                                            class="text-right"
                                        >
                                            Totals
                                        </td>
                                        <td
                                            class="font-weight-bold text-center pr-12"
                                            width="20%"
                                            style="font-size:14px;"
                                        >
                                            {{
                                                sumColumn(
                                                    Non,
                                                    'UPTTotal'
                                                ).toFixed(2)
                                            }}
                                        </td>
                                        <td
                                            class="font-weight-bold text-center pr-12"
                                            width="20%"
                                            style="font-size:14px;"
                                        >
                                            {{
                                                sumColumn(
                                                    Non,
                                                    'TotalPmt'
                                                ).toFixed(2)
                                            }}
                                        </td>
                                        <td
                                            class="font-weight-bold text-center pr-12"
                                            width="20%"
                                            style="font-size:14px;"
                                        >
                                            {{
                                                sumColumn(Non, 'Diff').toFixed(
                                                    2
                                                )
                                            }}
                                        </td>
                                    </tr>
                                </v-simple-table>

                                <!-- <v-row justify="end">
                                        <v-col cols="3">UPTTotal: {{ sumColumn(UnMatchs, 'UPTTotal').toFixed(2) }}</v-col>
                                        <v-col cols="3">Pmt Total: {{ sumColumn(UnMatchs, 'TotalPmt').toFixed(2) }}</v-col>
                                        <v-col cols="3">Diff Total: {{ sumColumn(UnMatchs, 'Diff').toFixed(2) }}</v-col>
                                </v-row> -->
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col cols="4">
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    label="Search"
                                    v-model="search"
                                    class="mb-5"
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-btn
                                    color="red"
                                    dark
                                    small
                                    class="float-right mt-3 mr-3"
                                    @click="getPdf"
                                >
                                    Download
                                    <v-icon class="ml-2"
                                        >mdi-file-pdf-box</v-icon
                                    >
                                </v-btn>
                                <v-btn
                                    color="success"
                                    class="float-right mt-3 mr-3"
                                    dark
                                    small
                                    @click="downloadExcel"
                                >
                                    Download
                                    <v-icon>mdi-microsoft-excel</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-data-table
                            :headers="headersMatch"
                            :items="Matchs"
                            :search="search"
                            dense
                        >
                            <template v-slot:top>
                                <v-toolbar color="primary" dense>
                                    <v-spacer />
                                    <v-toolbar-title class="white--text">
                                        Matched
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                            <!-- ... tus columnas ... -->
                            <template v-slot:footer>
                                <v-simple-table dense>
                                    <tr>
                                        <td
                                            colspan="2"
                                            width="40%"
                                            class="text-right"
                                        >
                                            Totals
                                        </td>
                                        <td
                                            class="font-weight-bold text-center pr-12"
                                            width="20%"
                                            style="font-size:14px;"
                                        >
                                            {{
                                                sumColumn(
                                                    Matchs,
                                                    'UPTTotal'
                                                ).toFixed(2)
                                            }}
                                        </td>
                                        <td
                                            class="font-weight-bold text-center pr-12"
                                            width="20%"
                                            style="font-size:14px;"
                                        >
                                            {{
                                                sumColumn(
                                                    Matchs,
                                                    'TotalPmt'
                                                ).toFixed(2)
                                            }}
                                        </td>
                                        <td
                                            class="font-weight-bold text-center pr-12"
                                            width="20%"
                                            style="font-size:14px;"
                                        >
                                            {{
                                                sumColumn(
                                                    Matchs,
                                                    'Diff'
                                                ).toFixed(2)
                                            }}
                                        </td>
                                    </tr>
                                </v-simple-table>

                                <!-- <v-row justify="end">
                                        <v-col cols="3">UPTTotal: {{ sumColumn(UnMatchs, 'UPTTotal').toFixed(2) }}</v-col>
                                        <v-col cols="3">Pmt Total: {{ sumColumn(UnMatchs, 'TotalPmt').toFixed(2) }}</v-col>
                                        <v-col cols="3">Diff Total: {{ sumColumn(UnMatchs, 'Diff').toFixed(2) }}</v-col>
                                </v-row> -->
                            </template>
                        </v-data-table>
                    </v-col>

                    <v-col cols="4">
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    label="Search"
                                    v-model="searchUnMatch"
                                    class="mb-5"
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-data-table
                            :headers="headersUnMatch"
                            :items="UnMatchs"
                            :search="searchUnMatch"
                            dense
                        >
                            <template v-slot:top>
                                <v-toolbar color="primary" dense>
                                    <v-spacer />
                                    <v-toolbar-title class="white--text">
                                        UnMatched
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>
                            <!-- ... tus columnas ... -->
                            <template v-slot:footer>
                                <v-simple-table dense>
                                    <tr>
                                        <td
                                            colspan="2"
                                            width="40%"
                                            class="text-right"
                                        >
                                            Totals
                                        </td>
                                        <td
                                            class="font-weight-bold text-center pr-12"
                                            width="20%"
                                            style="font-size:14px;"
                                        >
                                            {{
                                                sumColumn(
                                                    UnMatchs,
                                                    'UPTTotal'
                                                ).toFixed(2)
                                            }}
                                        </td>
                                        <td
                                            class="font-weight-bold text-center pr-12"
                                            width="20%"
                                            style="font-size:14px;"
                                        >
                                            {{
                                                sumColumn(
                                                    UnMatchs,
                                                    'TotalPmt'
                                                ).toFixed(2)
                                            }}
                                        </td>
                                        <td
                                            class="font-weight-bold text-center pr-12"
                                            width="20%"
                                            style="font-size:14px;"
                                        >
                                            {{
                                                sumColumn(
                                                    UnMatchs,
                                                    'Diff'
                                                ).toFixed(2)
                                            }}
                                        </td>
                                    </tr>
                                </v-simple-table>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['parms', 'title'],
    data: function() {
        return {
            headersMatch: [
                { text: 'InvId', value: 'UPTInvID', witdh: '20%' },
                // {text:'InvDate',value:'DateDelivered, witdh:'20%''},
                {
                    text: 'Bill Of Lading',
                    value: 'UPTBillofLading',
                    witdh: '20%'
                },
                // {text:'Date Delivered',value:'DeliveryDate, witdh:'20%''},
                { text: 'UPT Total', value: 'UPTTotal', witdh: '20%' },
                { text: 'Pmt Total', value: 'TotalPmt', witdh: '20%' },
                { text: 'Diff', value: 'Diff', witdh: '20%' }
            ],
            headersUnMatch: [
                { text: 'InvId', value: 'InvId', witdh: '20%' },
                // {text:'InvDate',value:'DateDelivered, witdh:'20%''},
                {
                    text: 'Bill Of Lading',
                    value: 'UPTBillofLading',
                    witdh: '20%'
                },
                // {text:'Date Delivered',value:'DeliveryDate, witdh:'20%''},
                { text: 'UPT Total', value: 'UPTTotal', witdh: '20%' },
                { text: 'Pmt Total', value: 'TotalPmt', witdh: '20%' },
                { text: 'Diff', value: 'Diff', witdh: '20%' }
            ],
            headersNon: [
                { text: 'InvId', value: 'InvId', witdh: '20%' },
                // {text:'InvDate',value:'DateDelivered, witdh:'20%''},
                { text: 'Bill Of Lading', value: 'BillOfLading', witdh: '20%' },
                // {text:'Date Delivered',value:'DeliveryDate, witdh:'20%''},
                { text: 'UPT Total', value: 'UPTTotal', witdh: '20%' },
                { text: 'Pmt Total', value: 'TotalPmt', witdh: '20%' },
                { text: 'Diff', value: 'Diff', witdh: '20%' }
            ],
            Matchs: [],
            Non: [],
            UnMatchs: [],
            itemsPerPageOptions: [10, 20, 30],
            Totals: {
                TotalNetAmount: null,
                TotalInvoiceNumber: null,
                TotalDiff: null
            },
            search: '',
            searchUnMatch: '',
            searchNon: ''
        };
    },

    mounted() {
        console.log(this.parms);
        this.getMatchs();
    },
    methods: {
        sumColumn(items, key) {
            return items.reduce(
                (acc, item) => acc + parseFloat(item[key]) || 0,
                0
            );
        },
        getPdf: function() {
            var str = this.$store;
            str.state.isLoading = true;
            this.parms.Pdf = true;
            console.log(this.parms);
            axios
                .post('conciliation/circle-k/summary-grp', this.parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        'Report Stmt by StmtDocument.pdf'
                    );
                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'This file is already uploaded.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        getMatchs: function() {
            var str = this.$store;
            str.state.isLoading = true;
            this.parms.Pdf = false;
            axios
                .post('conciliation/circle-k/summary-grp', this.parms)
                .then(async response => {
                    this.Matchs = response.data.filter(match => {
                        return match.Type == 'Matched';
                    });
                    this.UnMatchs = response.data.filter(match => {
                        return match.Type == 'UnMatched';
                    });
                    this.Non = response.data.filter(match => {
                        return match.Type == 'Non-Coinciliated';
                    });
                    this.Match = response.data;
                    console.log(this.Match);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'This file is already uploaded.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        downloadExcel: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            this.parms.Export = true;
            this.parms.Pdf = false;
            axios
                .post('conciliation/circle-k/summary-grp', this.parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;

                    link.setAttribute('download', this.title + '.xlsx');

                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
